import { paymentsApi } from '.';

export interface BraintreeExecuteRequest {
  client: string,
  nonce: string,
  transactionId: string,
  account_identifier: string,
  amount: number,
  currency: string,
  firstName: string,
  lastName: string,
  email: string,
  paymentType?: 'GOOGLEPAY' | 'APPLEPAY',
}

export interface BraintreeExecuteResponse {
  data: object,
  message: string,
}

const extendedPaymentsApi = paymentsApi.injectEndpoints({
  endpoints: builder => ({
    braintreeExecute: builder.mutation<BraintreeExecuteResponse, BraintreeExecuteRequest>({
      query: body => ({
        url: 'provider/braintree/execute',
        method: 'POST',
        body,
      })
    })
  })
});

export const { useBraintreeExecuteMutation } = extendedPaymentsApi;
